import * as React from 'react';
import { cn } from '@/lib/utils';
import { Slot } from '@radix-ui/react-slot';

const MedalWrapper = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-medal-wrapper',
      // styles
      'bg-gradient-[linear-gradient(9.59deg,#fff_20.02%,#F5F5F5_85.13%)] flex flex-wrap items-center gap-2.5 rounded-lg px-5 py-2.5 shadow-[0_4px_10px_rgba(68,43,140,0.05)]',
      className
    )}
    {...props}
  />
));
MedalWrapper.displayName = 'MedalWrapper';

const MedalWrapperInfo = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn(
      'c-medal-wrapper-info',
      // styles
      'mb-0 text-sm font-light text-neutral-dark',
      className
    )}
    {...props}
  />
));
MedalWrapperInfo.displayName = 'MedalWrapperInfo';

const MedalWrapperInfoBold = React.forwardRef(({ children, className, ...props }, ref) => (
  <strong
    ref={ref}
    className={cn('font-bold text-primary underline', className)}
    {...props}
  >
    {children}
  </strong>
));
MedalWrapperInfoBold.displayName = 'MedalWrapperInfoBold';

const MedalWrapperTitle = React.forwardRef(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={cn(
      'c-medal-wrapper-title',
      // styles
      'mb-0 block font-bold text-neutral-dark',
      className
    )}
    {...props}
  />
));
MedalWrapperTitle.displayName = 'MedalWrapperTitle';

const Medal = React.forwardRef(({ className, size, ...props }, ref) => {
  const sizeClasses = {
    md: 'size-[60px] text-2xl',
    gold: 'size-[60px] text-2xl',
    sm: 'size-8 text-sm',
    challenge: 'size-11 text-2xl',
    tia: 'size-[22px] text-xs'
  };

  return (
    <span
      ref={ref}
      className={cn(
        'c-medal',
        // styles
        'relative inline-block size-8 shrink-0 cursor-default text-base',
        size && sizeClasses[size],
        className
      )}
      {...props}
    />
  );
});
Medal.displayName = 'Medal';

const MedalImg = React.forwardRef(({ className, ...props }, ref) => (
  <img
    ref={ref}
    className={cn(
      'c-medal-img',
      // styles
      'block h-full w-full',
      className
    )}
    {...props}
  />
));
MedalImg.displayName = 'MedalImg';

const MedalValue = React.forwardRef(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={cn(
      'c-medal-value',
      // styles
      'absolute inset-0 flex items-center justify-center font-bold text-white',
      className
    )}
    {...props}
  />
));
MedalValue.displayName = 'MedalValue';

const MedalStars = React.forwardRef(({ className, ...props }, ref) => (
  <img
    ref={ref}
    className={cn(
      'c-medal-stars',
      // styles
      'absolute bottom-0 right-0 w-10 translate-x-[70%] translate-y-[30%]',
      className
    )}
    {...props}
  />
));
MedalStars.displayName = 'MedalStars';

const MedalStack = React.forwardRef(({ className, ...props }, ref) => (
  <ul
    ref={ref}
    className={cn(
      'c-medal-stack',
      // styles
      'flex min-w-0 cursor-pointer list-none items-center',
      className
    )}
    {...props}
  />
));
MedalStack.displayName = 'MedalStack';

const MedalStackItem = React.forwardRef(({ className, isLast = false, ...props }, ref) => (
  <li
    ref={ref}
    className={cn(
      'c-medal-stack-item',
      // styles
      'relative min-w-0',
      !isLast ? 'max-w-5' : '',
      className
    )}
    {...props}
  />
));
MedalStackItem.displayName = 'MedalStackItem';

const MedalStackImg = React.forwardRef(({ className, ...props }, ref) => (
  <img
    ref={ref}
    className={cn(
      'c-medal-stack-img',
      // styles
      'absolute left-0 w-14',
      className
    )}
    {...props}
  />
));
MedalStackImg.displayName = 'MedalStackImg';

export { MedalWrapper, MedalWrapperInfo, MedalWrapperInfoBold, MedalWrapperTitle, Medal, MedalImg, MedalValue, MedalStars, MedalStack, MedalStackItem, MedalStackImg };
